import IconWrapper, { IconWrapperProps } from "../IconWrapper";

type FlagSwedenProps = Pick<IconWrapperProps, "className">;

const FlagSweden = (props: FlagSwedenProps) => (
  <IconWrapper width={640} height={480} {...props}>
    <path fill="#005293" d="M0 0h640v480H0z" />
    <path fill="#fecb00" d="M176 0v192H0v96h176v192h96V288h368v-96H272V0z" />
  </IconWrapper>
);

export default FlagSweden;
